import { Box, BoxProps, CircularProgress, Typography } from '@mui/material';

interface LoadingProps extends Omit<BoxProps, 'content'> {
  content?: string | null;
  height?: number;
}

export const Loading = ({ content = 'Data Loading...', height = 250, ...props }: LoadingProps) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      my={5}
      gap={4}
      sx={{ height }}
      {...props}
    >
      <CircularProgress sx={{ maxHeight: height, maxWidth: height }} />
      {content && <Typography variant="subtitle2">{content}</Typography>}
    </Box>
  );
};
